import axios from "axios";
import settings from "../settings/settings.js"
import router from '../router/index.js';


let source;
const ajax = axios.create({
    baseURL: settings.baseUrlApi,
})

ajax.interceptors.request.use((config) => {
    let token = localStorage.getItem('auth')
    if (navigator.onLine) {
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    }
    else {
        return false;
    }

}, (error) => {
    console.log(error)
    if (error.response.status === 401) {
        // localStorage.removeItem("auth");
        // localStorage.removeItem("user");
        // this.$router.go();
    }
    return Promise.reject(error)
})

ajax.interceptors.response.use(response => {
    return response;
},
    error => {
        if (error.response.status === 401) {
            localStorage.removeItem("auth");
            localStorage.removeItem("user");
            router.go();
        }
        // if(error.response.status === 400 || error.response.status === 404)
        // {
        //     window.location.href = "/Error"
        // }
        else if (error.response.status === 404) {
            router.push({ name: "Error", params: { status: 404 } })
        }
        else if (error.response.status === 403) {
            router.push({ name: "Error", params: { status: 403 } })
        }
        else {
            //window.location.href = `${settings.baseUrl}/Error`
        }
        let html = ''
            console.log(error.response.data.message)
            let errs;
            try{
                errs = JSON.parse(error.response.data.message)
            }
            catch(e){
                errs = error.response.data.message
            }
            if (Array.isArray(errs)) {
                errs.forEach(err => {
                    html += err + "</br>"
                });
                return Promise.reject(html);
            }{
                html = errs
                return Promise.reject(html);
            }
        // return Promise.reject(error)

    })


export default {

    // source,








    //GET
    getProjects(archived = false, linkedUser = null) {
        if (linkedUser) {
            return ajax.get(`${settings.baseUrlApi}/Projects?archived=${archived}&linkedUser=${linkedUser}`)
        }
        return ajax.get(`${settings.baseUrlApi}/Projects?archived=${archived}`)
    },

    getProject(id) {
        return ajax
            .get(settings.baseUrlApi + `/Projects/${id}`)
    },

    getBuildingComponents(id) {
        return ajax
            .get(settings.baseUrlApi + `/BuildingComponentsByProjectId/${id}`)
    },

    getBuildingComponent(id) {
        return ajax
            .get(settings.baseUrlApi + `/BuildingComponents/${id}`)
    },
    getBlueprints(id) {
        return ajax
            .get(settings.baseUrlApi + `/BlueprintsByBuildingComponentId/${id}`)
    },

    getBlueprint(id) {
        return ajax
            .get(settings.baseUrlApi + `/Blueprints/${id}`)
    },

    getMarkers(id, light = false) {
        if (source) {
            source.cancel();
        }
        const CancelToken = axios.CancelToken;
        source = CancelToken.source();
        return ajax
            .get(settings.baseUrlApi + `/MarkersByBlueprintId/${id}?languageCode=${localStorage.getItem('language')}&light=${light}`,
                {
                    cancelToken: source.token
                })
    },

    getMarker(id) {
        return ajax
            .get(settings.baseUrlApi + `/Markers/${id}?languageCode=${localStorage.getItem('language')}`)
    },
    getAttributes(offline, visible) {
        return ajax.get(settings.baseUrlApi + `/QRLogAttributes?languageCode=${localStorage.getItem('language')}&offline=${offline}&visible=${visible}`)
    },

    getUnusedAttributes(markerId) {
        return ajax.get(settings.baseUrlApi + `/QRLogAttributesUnused/${markerId}?languageCode=${localStorage.getItem('language')}`)
    },
    getUnusedAttributes2(markerxSolutionsId) {
        return ajax.get(settings.baseUrlApi + `/QRLogAttributesUnused2/${markerxSolutionsId}?languageCode=${localStorage.getItem('language')}`)
    },

    getAttributeClasses() {
        return ajax.get(settings.baseUrlApi + `/QRLogAttributeClasses?languageCode=${localStorage.getItem('language')}`)
    },
    showValues(attributeId) {
        return ajax
            .get(settings.baseUrlApi + `/QRLogAttributeListValuesByAttributeId/${attributeId}?languageCode=${localStorage.getItem('language')}`)
    },
    getLanguages() {
        return ajax
            .get(settings.baseUrlApi + "/Languages")
    },

    // getProductSolutions(includeEcommerce = false) {
    //     return ajax
    //         .get(settings.baseUrlApi + `/ProductSolutions/${includeEcommerce}`)
    // }
    getProductSolutions(includeEcommerce = false, search = "") {
        return ajax
            .get(settings.baseUrlApi + `/ProductSolutions/${includeEcommerce}?search=${search}&languageCode=${localStorage.getItem("language")}`)
    },

    getPIMProductSolutions() {
        return ajax
            .get(settings.baseUrlApi + `/PIMProductSolutions?languageCode=${localStorage.getItem("language")}`)
    },

    getLocalProductSolutions() {
        return ajax
            .get(settings.baseUrlApi + `/Products`)
    },

    getProductsBySolutionId(productSolutionId, includeEcommerce = false) {
        return ajax
            .get(settings.baseUrlApi + `/ProductSolutions/${productSolutionId}?includeEcommerce=${includeEcommerce}&languageCode=${localStorage.getItem("language")}`)
    },

    getProductById(id) {
        return ajax
            .get(settings.baseUrlApi + `/Products/${id}`)
    },

    getProducts(includeEcommerce = false, search) {
        return ajax
            .get(settings.baseUrlApi + `/Products/${includeEcommerce}?search=${search}&languageCode=${localStorage.getItem("language")}`)
    },
    syncAttributes() {
        return ajax
            .get(settings.baseUrlApi + "/SyncAttributes")
    },

    getMarkerByQRId(id, markerId) {
        return ajax
            .get(`${settings.baseUrlApi}/QR/${id}?markerId=${markerId}`)
    },
    getMarkerId(qrId,languageCode) {
        return ajax
            .get(`${settings.baseUrlApi}/QR/${qrId}?languageCode=${languageCode}`)
    },

    getLog(form) {
        return ajax({
            url: `${settings.baseUrlApi}/Log`,
            method: 'POST',
            data: form,
            headers: {
                'content-type': `multipart/form-data; boundary=${form._boundary}`,
            },
            responseType: 'blob',
        })
    },
    downloadQRStickers(amount, type) {
        return ajax({
            url: `${settings.baseUrlApi}/QRStickers?amount=${amount}&type=${type}&lc=${localStorage.getItem("language")}`,
            method: 'GET',
            responseType: 'blob',
        })
    },
    downloadExcelExport(projectId = '', buildingComponentId = '', blueprintId = '') {
        return ajax({
            url: `${settings.baseUrlApi}/ExcelExport?projectId=${projectId}&buildingComponentId=${buildingComponentId}&blueprintId=${blueprintId}&lc=${localStorage.getItem("language")}`,
            method: 'GET',
            responseType: 'blob',
        })
    },


    getTodo() {
        return ajax
            .get(settings.baseUrlApi + `/Todo`)
    },

    getReports() {
        return ajax
            .get(settings.baseUrlApi + `/Report`)
    },
    getOldReports() {
        return ajax
            .get(settings.baseUrlApi + `/Report/old`)
    },
    downloadLogbook(projectId = '', buildingComponentId = '',separated = false,withDocuments = false) {
        return ajax({
            url: settings.baseUrlApi + `/DownloadLogbook?projectId=${projectId}&buildingComponentId=${buildingComponentId}&languageCode=${localStorage.getItem("language")}&blueprintSeparated=${separated}&withDocuments=${withDocuments}`,
            method: 'GET',
            responseType: 'blob'
        })
    },

    getHelp() {
        return ajax
            .get(settings.baseUrlApi + '/Help?languageCode=' + localStorage.getItem("language"))
    },
    getStickerTemplate() {
        return ajax
            .get(settings.baseUrlApi + '/StickerTemplates')
    },

    getInstallers() {
        return ajax.get(settings.baseUrlApi + '/Installers')
    },

    getLicenseInfo() {
        return ajax.get(settings.baseUrlApi + '/Licenses')
    },

    getUnprocessedRequest() {
        return ajax.get(`${settings.baseUrlApi}/NotificationCustomers`)
    },
    getStorageUpgrades() {
        return ajax.get(`${settings.baseUrlApi}/FirelogStorageUpgrades`)
    },
    getNotifications() {
        return ajax.get(`${settings.baseUrlApi}/Notifications`)
    },

    getTodosGroupedByInstaller(){
        return ajax.get(`${settings.baseUrlApi}/Todo/Installers`)
    },
    getReleaseNotes(){
        return ajax.get(`${settings.baseUrlApi}/ReleaseNotes`)
    },

    getAccounts(s){
        if (source) {
            source.cancel();
            console.log('cancelled')
        }
        const CancelToken = axios.CancelToken;
        source = CancelToken.source();
        return ajax
            .get(`${settings.iHubBaseUrlApi}/CustomerContactOverview?search=${s}`,
                {
                    cancelToken: source.token
                })
    },





















    //POST
    addProject(project) {
        return ajax
            .post(`${settings.baseUrlApi}/Projects`, project)
    },

    addBuildingComponent(buildingComponent) {
        return ajax
            .post(settings.baseUrlApi + `/BuildingComponents`, buildingComponent)
    },

    addBlueprint(blueprint) {
        return ajax
            .post(settings.baseUrlApi + `/Blueprints`, blueprint)
    },
    addBlueprintFile(form) {
        return ajax({
            url: `${settings.baseUrlApi}/Blueprints/upload`,
            method: 'POST',
            data: form,
            headers: {
                'content-type': `multipart/form-data; boundary=${form._boundary}`,
            },
        })
    },

    addMarker(marker) {
        return ajax
            .post(settings.baseUrlApi + `/Markers?languageCode=${localStorage.getItem('language')}`, marker)
    },

    uploadMarkerAttachment(formData, markerId) {
        return ajax
            .post(settings.baseUrlApi + `/AttachmentsFile?markerId=${markerId}`, formData);
    },

    uploadMarkerAttachmentByCamera(attachment) {
        return ajax
            .post(settings.baseUrlApi + `/Attachments?languageCode=${localStorage.getItem('language')}`, attachment);
    },

    postAttributesForMarker(qrLogAttributeXMarkers) {
        return ajax
            .post(
                settings.baseUrlApi + "/QRLogAttributeXMarkersList",
                qrLogAttributeXMarkers
            )
    },

    saveAttribute(attribute) {
        return ajax
            .post(settings.baseUrlApi + `/QRLogAttributes?languageCode=${localStorage.getItem('language')}`, attribute)
    },
    saveAttributeValue(data) {
        return ajax
            .post(settings.baseUrlApi + `/QRLogAttributeListValues?languageCode=${localStorage.getItem('language')}`, data)
    },
    addInstaller(installer) {
        return ajax
            .post(settings.baseUrlApi + "/Installers", installer)
    },
    addSolution(form) {
        // return ajax
        //     .post(settings.baseUrlApi + "/ProductSolutions", solution)

        return ajax({
            url: `${settings.baseUrlApi}/ProductSolutions`,
            method: 'POST',
            data: form,
            headers: {
                'content-type': `multipart/form-data; boundary=${form._boundary}`,
            },
        })
    },

    addProduct(solutionId, product) {
        return ajax
            .post(settings.baseUrlApi + `/Products?productSolutionId=${solutionId}`, product)
    },

    login(creadentials) {
        return axios.post(settings.iHubBaseUrlApi + "/Authentication/Login", creadentials)
    },
    loginAsCustomer(data){
        return ajax.post(settings.iHubBaseUrlApi + "/Authentication/LoginAsCustomer", data)
    },
    updateAttributesPosition(attributes) {
        return ajax
            .post(settings.baseUrlApi + '/SortAttributes', attributes)
    },

    addSelectedProducts(selectedProducts) {
        return ajax
            .post(settings.baseUrlApi + `/PostSelectedProducts`, selectedProducts)
    },

    addReport(report) {
        return ajax
            .post(settings.baseUrlApi + `/Report`, report)
    },

    // addAttachment(form){
    //     return ajax.post(settings.baseUrlApi + `ProductAttachments`, form)
    // },




    uploadAttachment(form) {
        return ajax({
            url: `${settings.baseUrlApi}/UploadProductAttachment`,
            method: 'POST',
            data: form,
            headers: {
                'content-type': `multipart/form-data; boundary=${form._boundary}`,
            },
        })
    },

    uploadLogo(form) {
        return ajax({
            url: `${settings.baseUrlApi}/StickerTemplates`,
            method: 'POST',
            data: form,
            headers: {
                'content-type': `multipart/form-data; boundary=${form._boundary}`,
            },
        })
    },


    forgotPasswordChallenge(email) {
        return ajax.post(settings.baseUrlApi + '/Authenticaton/ForgotPasswordChallenge', { email: email })
    },

    forgotPasswordChallengeCheck(token) {
        return ajax.post(settings.baseUrlApi + '/Authenticaton/ForgotPasswordChallengeCheck', { token: token })
    },

    forgotPasswordReset(password, token) {
        return ajax.post(settings.baseUrlApi + '/Authenticaton/ForgotPasswordReset', { password: password, token })
    },

    postRequest(data) {
        return ajax.post(`${settings.baseUrlApi}/NotificationCustomers`, data)
    },
    upgradeStorage(data) {
        return ajax.post(`${settings.baseUrlApi}/FirelogStorageUpgrades`, data)
    },

    updateProjectsXInstallers(data) {
        return ajax.post(`${settings.baseUrlApi}/Projects/AddUsers`, data)
    },

    updateBuildingComponentsXInstallers(data) {
        return ajax.post(`${settings.baseUrlApi}/BuildingComponents/AddUsers`, data)
    },
    updateBlueprintXInstallers(data) {
        return ajax.post(`${settings.baseUrlApi}/Blueprints/AddUsers`, data)
    },
    acceptTermsOfService(){
        return ajax
        .post(`${settings.baseUrlApi}/Licenses/AcceptTerms`)
    },

    readReleaseNotes(){
        return ajax
        .post(`${settings.baseUrlApi}/ReleaseNotes`)
    },
    cloneQRLogAttribute(a){
        return ajax
        .post(`${settings.baseUrlApi}/QRLogAttributes/Clone`,a)
    },


































    //DELETE
    deleteProject(id) {
        return ajax.delete(`${settings.baseUrlApi}/Projects/${id}`)
    },
    deleteBuildingComponents(id) {
        return ajax
            .delete(settings.baseUrlApi + `/BuildingComponents/${id}`)
    },
    deleteBlueprint(id) {
        return ajax
            .delete(settings.baseUrlApi + `/Blueprints/${id}`)
    },
    deleteMarker(id) {
        return ajax
            .delete(settings.baseUrlApi + `/Markers/${id}`)
    },
    deleteAttachment(id) {
        return ajax
            .delete(settings.baseUrlApi + `/Attachments/${id}`)
    },
    deleteValues(valueId) {
        return ajax
            .delete(settings.baseUrlApi + `/QRLogAttributeListValues/${valueId}`)
    },

    deleteAttribute(id) {
        return ajax
            .delete(settings.baseUrlApi + `/QRLogAttributes/${id}`)
    },

    deleteMarkerXSolution(id) {
        return ajax.delete(settings.baseUrlApi + `/MarkerXSolutions/${id}`)
    },
    deleteSolutionXproduct(id, fk) {
        return ajax.post(settings.baseUrlApi + `/ProductSolutions?id=${id}&fk=${fk}`, id)
        //.post(settings.baseUrlApi + `/DeleteProductSolutions?fk=${fk}`, id)
    },
    deleteProductSolution(id) {
        return ajax.delete(settings.baseUrlApi + `/ProductSolutions/${id}`)
    },

    deleteProductAttachment(id) {
        return ajax.delete(settings.baseUrlApi + `/DeleteProductAttachment/${id}`)
    },

    deleteReport(id) {
        return ajax.delete(settings.baseUrlApi + `/Report/${id}`)
    },

    deleteBlueprintFile(id){
        return ajax.delete(`${settings.baseUrlApi}/Blueprints/BlueprintFile/${id}`)
    },































    //PUT
    updateProject(project) {
        return ajax.put(settings.baseUrlApi + `/Projects/${project.id}`, project)
    },

    updateBlueprint(blueprint) {
        return ajax
            .put(settings.baseUrlApi + `/Blueprints/${blueprint.id}`, blueprint)
    },
    updateBuildingComponent(buildingComponent) {
        return ajax
            .put(settings.baseUrlApi + `/BuildingComponents/${buildingComponent.id}`, buildingComponent)
    },
    updateMarker(marker) {
        return ajax
            .put(settings.baseUrlApi + `/Markers/${marker.id}?languageCode=${localStorage.getItem('language')}`, marker)
    },
    updateAttributesForMarker(qrLogAttributeXMarkers) {
        return ajax
            .put(
                settings.baseUrlApi + "/QRLogAttributeXMarkersList",
                qrLogAttributeXMarkers
            )
    },

    updateAttribute(qRLogAttributes) {
        return ajax
            .put(`${settings.baseUrlApi}/UpdateQRLogAttributes?languageCode=${localStorage.getItem('language')}`, qRLogAttributes)
    },
    updateAttributeValues(qRLogAttributeValues) {
        return ajax
            .put(`${settings.baseUrlApi}/UpdateQRLogAttributeValues?languageCode=${localStorage.getItem('language')}`, qRLogAttributeValues)
    },
    updateAttributeValue(qRLogAttributeValue) {
        return ajax
            .put(`${settings.baseUrlApi}/UpdateQRLogAttributeValues?id=${qRLogAttributeValue.id}`, qRLogAttributeValue)
    },
    changeVisibility(attribute) {
        return ajax
            .put(`${settings.baseUrlApi}/QRLogAttributes/${attribute.id}`, attribute)
    },
    updateSolution(solution) {
        return ajax
            .put(settings.baseUrlApi + `/Products/${solution.id}`, solution)
    },
    lockBlueprint(id, breakLock) {
        return ajax.get(settings.baseUrlApi + `/LockBlueprint/${id}/${(breakLock !== undefined ? breakLock : '')}`)
    },
    hidePIMSolution(id) {
        return ajax.get(settings.baseUrlApi + `/HidePIMProductSolutions/${id}`)
    },
    unhidePIMSolution(id) {
        return ajax.get(settings.baseUrlApi + `/UnHidePIMProductSolutions/${id}`)
    },

    updateCustomerContact(user) {
        return ajax
            .put(
                settings.baseUrlApi + `/Installers?id=${user.CustomerContactId}`, user
            )
    },
    takeOverBlueprintEdit(id){
        return ajax
            .put(
                `${settings.baseUrlApi}/Blueprints/takeover/${id}`
            )
    }


}



// WEBPACK FOOTER //
// ./src/services/service.js